import FalconComponentCard from "components/common/FalconComponentCard";
import React from "react";
import { Button, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate, useParams } from "react-router-dom";
import AddEmpolyeeForm from "./AddEmpolyeeForm";
import moment from "moment";
import { CreateEmpolyee } from "../config/empolyeeApi";
import { toast } from "react-toastify";
import paths from "routes/paths";
import BackButton from "components/common/custom/back-button";

const AddEmpolyee = ({ view }) => {
  const dispatch = useDispatch();
  const { allPermissionType } = useSelector((state) => state.role);
  const empolyeeSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Employee"
  );
  const {
    control,
    watch,
    setValue,
    reset,
    clearErrors,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      empolyee_id: "",
      first_name_eng: "",
      first_name_arabic: "",
      father_name_eng: "",
      father_name_arabic: "",
      family_name_eng: "",
      family_name_arabic: "",
      nationality: "",
      mobile_no: "",
      id: "",
      birth_date: "",
      branch: "",
      system_privilages: "",
      username: "",
      password: "",
    },
  });

  const navigate = useNavigate();

  const { id } = useParams();

  const handleReset = () => {
    reset();
  };

  const handleAddEmpolyee = async (data) => {
    const payload = {
      ...(id && { employees_id: id }),
      employees_firstname: data?.first_name_eng || "",
      employees_firstname_arabic: data?.first_name_arabic || "",
      employees_fathername: data?.father_name_eng || "",
      employees_fathername_arabic: data?.father_name_arabic || "",
      employees_familyname: data?.family_name_eng || "",
      employees_familyname_arabic: data?.family_name_arabic || "",
      employees_mobilenumber: data?.mobile_no || "",
      employees_emailid: data?.email || "",
      employees_dob: data?.birth_date
        ? moment(data?.birth_date).format("YYYY-MM-DD")
        : "" || "",
      employees_nationality: data?.nationality?.value || "",
      branch_cchi: data?.branch?.map((item) => item?.cchi)?.join(","),
      employees_nationalid: data?.national_id || "",
      syspri_id:
        data?.system_privilage?.value ||
        data?.system_privilage?.syspri_id ||
        "",
      employees_esspassword: data?.password || "",
    };

    const response = await dispatch(CreateEmpolyee(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.employeeList);
      reset();
    } else {
      toast.error(response?.message_en);
    }
  };

  return (
    <>
      {((id ? Number(empolyeeSetting?.edit) === 1 : Number(empolyeeSetting?.add) === 1) || (view && Number(empolyeeSetting?.view) === 1)) ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleAddEmpolyee)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <BackButton
                path={paths.employeeList}
                title={`${id ? (view ? "View" : "Update") : "Add"} User`}
              />
              <Col xs="auto" className="d-flex gap-2">
                {!view && (
                  <>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button type="submit" size="sm" variant="success">
                      {id ? "Update" : "Add"}
                    </Button>
                  </>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <AddEmpolyeeForm
                watch={watch}
                setValue={setValue}
                errors={errors}
                control={control}
                clearErrors={clearErrors}
                isSubmitted={isSubmitted}
                view={view}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to {view ? "view" : (id ? "edit" : "add")} User.
          </p>
        </div>
      )}
    </>
  );
};

export default AddEmpolyee;
